const formatProductName = (product) => {
    if (product === "ProWatch") return "Pro-Watch";
    if (product === "Camera") return "Cameras";
    if (product === "MBSecure") return "MB Secure";
    if (product === "IQ_MultiAccess") return "IQ MultiAccess";
    if (product === "WINMAG_Plus") return "WINMAG Plus";
    if (product === "MBI") return "MPI";
    return product;
};

export default formatProductName;
